import MyTabs from '../../components/MyTabs';
import Section1 from './Section1'

const GeneralCalendarFocusOfTheDay = () => {

    const tabs = [
        { id: "Basic", title: "Basic Calendar Focus Of The Day Info", Component: Section1 },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralCalendarFocusOfTheDay;